module.exports = __webpack_public_path__ + "img/P1 (2).7854cffc.png";